<div class="cp-backdrop" role="dialog" aria-modal="true" aria-label="Pulso de clima laboral" *ngIf="question$ | async as q">
  <div class="cp-card">
    <div class="cp-shapes" aria-hidden="true"><i class="cp-shape cp-shape--a"></i><i class="cp-shape cp-shape--b"></i></div>

    <ng-container *ngIf="!thanks; else gracias">
      <div class="cp-hero">
        <app-breaky [pose]="pose" [size]="104" motion="idle"></app-breaky>
        <div class="cp-bubble">
          <span class="cp-tag">Pulso quincenal · 1 pregunta</span>
          <strong>{{ q.text }}</strong>
        </div>
      </div>

      <div class="cp-faces" role="radiogroup" aria-label="Tu valoración de 1 a 5">
        <button
          *ngFor="let f of faces"
          type="button"
          role="radio"
          class="cp-face"
          [class.cp-face--on]="selected === f.value"
          [attr.aria-checked]="selected === f.value"
          [attr.aria-label]="f.value + ' de 5: ' + f.label"
          (click)="selected = f.value"
        >
          <span class="cp-emoji">{{ f.emoji }}</span>
          <span class="cp-label">{{ f.label }}</span>
        </button>
      </div>

      <p class="cp-privacy"><span aria-hidden="true">🔒</span> {{ privacyNote }}</p>
      <p class="cp-error" *ngIf="error" role="alert">No pudimos enviar tu respuesta. Inténtalo de nuevo.</p>

      <div class="cp-actions">
        <button type="button" class="cp-skip" (click)="skip()">Ahora no</button>
        <button type="button" class="cp-send" (click)="send()" [disabled]="!selected || sending">
          {{ sending ? 'Enviando...' : 'Enviar' }}
        </button>
      </div>
    </ng-container>

    <ng-template #gracias>
      <div class="cp-thanks" role="status">
        <app-breaky [pose]="pose" [size]="120" motion="bounce"></app-breaky>
        <strong>¡Gracias por tu opinión!</strong>
        <span>Tu respuesta es anónima y ayuda a mejorar el ambiente de tu equipo.</span>
      </div>
    </ng-template>
  </div>
</div>
